export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const REPORT_BASE_URL = process.env.REACT_APP_REPORT_API_BASE_URL;
export const OPEN_FILE_DOWNLOAD_URL = process.env.REACT_APP_OPEN_FILE_DOWNLOAD_URL;
const CHATBOT_BASE_URL = process.env.REACT_APP_CHATBOT_API_BASE_URL;

export const API_BASES = {
  CORE: BASE_URL,
  REPORT: REPORT_BASE_URL,
  CHATBOT: CHATBOT_BASE_URL,
};
